export const GET_QUESTION_REQUEST = "GET_QUESTION_REQUEST"
export const GET_QUESTION_SUCCESS = "GET_QUESTION_SUCCESS"
export const GET_QUESTION_ERROR = "GET_QUESTION_ERROR"

export const POST_QUESTION_REQUEST = "POST_QUESTION_REQUEST"
export const POST_QUESTION_SUCCESS = "POST_QUESTION_SUCCESS"
export const POST_QUESTION_ERROR = "POST_QUESTION_ERROR"

export const SET_QUESTION_DATA = "SET_QUESTION_DATA"